export enum TnPortalType {
  LEGACY = 'LEGACY',
  NUSO = 'NUSO'
}
